<!-- 3. 계약서 전송 -->
<template>
  <v-row no-gutters>
    
    <!--내용-->
    <v-col cols="12" class="write_conYscroll">
        <v-row no-gutters>
          <v-col cols="12" class="docuD_pop_tcp_box">
              <ul class="pattern_ulTxtBox">
                <li>
                  <span class="txt_icon">요청</span>
                  <span class="txt_txt01">{{ ctrGlobalFrm.senderName }}</span>
                </li>
              </ul>
            </v-col>
            <v-col cols="12" class="docuD_pop_tcp_box">
              <ul class="pattern_ulTxtBox">
                <li>
                  <span class="txt_icon">블록체인</span>
                  <span class="txt_txt02">{{ ctrGlobalFrm.senderAddress }}</span>
                </li>
              </ul>
            </v-col>
            <v-col cols="12" class="mt-2">              
              <v-text-field class="inputH48_01 W100"
                label="코멘트"
                placeholder="수신자 메일에 코멘트를 남겨주세요"
                maxlength="200"
                outlined
                dense
								v-model="emailMessage"
              >
              </v-text-field>
              <v-text-field class="inputH48_01 conBstar"
                label="블록체인 비밀번호"
                placeholder="블록체인 비밀번호 입력"
                outlined
                dense
								v-model="ctrFrmStep3A.ctrBlckChainPw"
								:type="'password'"
              >
              </v-text-field>
              <span class="txtst_info_red">- 블록체인 인증이 완료되어야 계약서 전송이 완료됩니다.</span>
            </v-col>
        </v-row>
    </v-col>

		<v-footer bottom class="steperF_btnCon justify-center">
        <v-btn outlined class="btn19_00" @click="prevStep()"><span class="iconarr stP"></span>이전</v-btn>
        <v-btn class="btn19_C01"  @click="ContractCharge(keyNames.frmName.ctrFrmStep3A)" v-if="personalBrokerPrcFlag === keyNames.ctrKind.personal">전송</v-btn>
				<v-btn class="btn19_C01"  @click="ctrSetBlckChainPw(keyNames.frmName.ctrFrmStep3A)" v-else>전송</v-btn>
    </v-footer>
		<ctr-reqeust-dialog ref="ctrReqeustDialog" :parent-data="reqParamJson" @ctrevent="signature"></ctr-reqeust-dialog>
		<pg-request ref="pgRequest" :signal="personalBrokerPrcFlag" :parent-data="reqParamJson" @pgEvent="PGResponse"></pg-request>
		
  	<s-confirm ref="confirm"></s-confirm>
  	<s-loading ref="loading"></s-loading>
		<!--결제-기업-->
    <v-dialog
      v-model="payEnd"
      max-width="600px"
      persistent>
      <v-card id="popStyle02">
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
            <v-col cols="12" class="ta_center row_mb-40">
              <div class="payEnd_view" v-if="this.personalBrokerPrcFlag === 'BROKER'">
                <span class="icon01"></span>
                <span class="txt01">요금정보</span>
                <span class="txt02">
                  <span class="txtst_info_gray mr-2">차감</span><span class="txtst_info_red">{{ usePoint }}p</span> / <span class="txtst_info_gray mr-2">잔여</span><span class="fc_C03">{{ totalPoint }}</span>
                </span>
              </div>              
              <div>계약요청이 완료 되었습니다.<br>미처리함으로 이동하시겠습니까?</div>
            </v-col>
          </v-row>
        </v-card-text>
        <!--/팝업 내용-->
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn text @click="payEndMove('write')">계약작성</v-btn>
          <!--미처리함 이동-->
          <v-btn text @click="payEndMove('storage')">미처리함</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
    <!--/결제-기업-->
</v-row>

</template>
<script>
import {
	convFrmDataToReqJsonParam,
	makeNewCtrParamsByStep,
	writeContractData,
	validateBkPass,
  defaultConstValue
} from '@/api/contract/addNew'
import ctrReqeustDialog from '@/views/contract/addNew/components/ctrReqeustDialog'
import pgRequest from '@/components/pgRequest'


const KEY_NAMES_OBJ = defaultConstValue()

export default {
  name: 'requestCtr',
  components: {
		ctrReqeustDialog,
		pgRequest
  },
  props: {
    parentData: {}
	},
  created () {
  },
  filters: {
  },
  data () {
    return {
      ctrRequest: 'Y',
			paymentBuyer: '',
			paymentEmail: '',
			payEnd: false,
			keyNames: KEY_NAMES_OBJ, 
			reqParamJson: {},
			personalBrokerPrcFlag: '', // PERSONAL : 개인계약, BROKER : 계약대행
			tmpUploadPrc: {
        ctrPaperUpInfo: {},
        ctrPaperAttachInfo: []
			},
			purCertInfo: {
        certRegNo: '',
        hash: ''
			},
			step: 3,
			ctrGlobalFrm: {
        ctrNo: '',
        ownerAddress: '',
        ownerName: '',
        senderAddress: '',
        senderName: '',
        senderBrokerAddress: '',
        senderBrokerName: '',
        receiverAddress: '',
        receiverName: '',
        receiverBrokerAddress: '',
        receiverBrokerName: '',
        receiverBrokerChkYN: false,
        receiverEmail: '',
        receiverPhone: '',
        receiverOrgNum: '',
        receiverKey: '',
        ctrLockType: '',
        ctrSignType: '',
        ctrEmailMessage: ''
			},
			certResultData: {
        certPEM: '',
        certSign: ''
			},
			emailMessage: '',
			paymentPGSeq: null,
			pg: {
        pgSeq: ''
			},
			ctrFrmStep3A: {
        isCertReqBlckChain: false,
        ctrBlckChainPw: ''
			},
			pdfConvPrc: {
        convPdfReqId: '',
        isPDFConvFail: false,
        isFinishConvPDF: false,
        isConvPDFPathOK: false,
        isConvPDFPathOKToMakeThumb: false,
        recursiveCallChkPDFPathLimit: 0,
        recursiveCallThresholdCnt: 10, // PDF 썸네일 만들기 위해 callback 지연에 대한 검사 제한 횟수
        isExecWmPrc: false, // 워터마크 프로세스 실행 여부
        convertedPDFThumbNail: '',
        defaultThumbNailView: 'https://png.icons8.com/color/240/000000/pdf-2.png',
        viewPdfThumbUrl: ''
			},
			usePoint: 0,
			totalPoint: 0
		}
	},
	mounted () {
		this.reqParamJson = this.parentData
		this.ctrGlobalFrm = this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm]
		this.personalBrokerPrcFlag = this.reqParamJson[this.keyNames.frmName.ctrFrmStep1].ctrKind
		
		this.$nextTick(() => {
			this.ctrDialogOpen()
		})
  },
	methods: {
		ctrDialogOpen() {
			var ctrTypeFlag = ''
			if (this.getOrgname()) {
				ctrTypeFlag = this.keyNames.ctrKind.broker
			}else {
				ctrTypeFlag = this.keyNames.ctrKind.personal
			}
      this.$refs.ctrReqeustDialog.open(this.reqParamJson, ctrTypeFlag)
		},
		getOrgname() {
      return this.$store.state.user.orgname
		},
		prevStep () {
			this.$emit('prevStep', this.step, this.reqParamJson)
		},
		signature(certResultData) {
      this.ctrRequest = 'N'
			this.certResultData = certResultData
		},
		ContractCharge (frmNm) {
			if ((this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].ctrSignType === 1 && this.certResultData.certPEM === '') || this.ctrRequest === 'Y') {
				this.ctrDialogOpen()
			}else {
				// 개인 계약 생성
				this.PgTempcertStatCode = ''
				this.PgTempcertResMsg = ''
        this.$refs.loading.start('결제 요청 처리 중입니다.')
        
				this.makeReqParamByStep(this.keyNames.frmName.ctrFrmStep3)
				this.makeReqParamByStep(this.keyNames.frmName.ctrFrmStep3A)

				var isValidDatasToReq = this.validateFinalDataToReq().isValidDatasToReq
				if (isValidDatasToReq) {
					var ownerAddress = this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].ownerAddress

					validateBkPass({ ownerAddress: ownerAddress, ctrBlckChainPw: this.ctrFrmStep3A.ctrBlckChainPw }).then(response => {
						if (response.rcode === 20000) {
							this.$nextTick(() => {
								
								this.$refs.loading.end()
								if (response.rdata.validate) {
									this.PGCall()
								} else {
									this.$refs.confirm.open('alert', '', response.rdata.msg)
								}
							})
						} else {
							this.ctrFrmStep3A.ctrBlckChainPw = ''

							this.$refs.loading.end()
							this.$refs.confirm.open('alert', '', '블록체인 암호 인증에 실패하였습니다. 다시 작업해 주세요.')
						}
					}).catch(() => {
						this.ctrFrmStep3A.ctrBlckChainPw = ''

						this.$refs.loading.end()
						this.$refs.confirm.open('alert', '', '블록체인 암호 인증에 실패하였습니다. 다시 작업해 주세요.')
					})
				} else {
					this.$refs.confirm.open('alert', '', '잘못된 작업이 있어 계약요청 할 수 없습니다. 다시 작업해 주세요.')
					// 모든작업사항을 초기화 하고 step1로 이동한다
					// this.initAllProgress()
					// 블록체인 인증암호 초기화
					this.ctrFrmStep3A.ctrBlckChainPw = ''

					this.$refs.loading.end()
				}
			}
		},
		ctrSetBlckChainPw (frmNm) {
			if ((this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].ctrSignType === 1 && this.certResultData.certPEM === '') || this.ctrRequest === 'Y') {
				this.ctrDialogOpen()
			}else {
				// 기업 계약 생성
				// 계약요청을 먼저 하고, 블록체인 암호 인증 요청을 한다.
				this.$refs.loading.start('계약요청 내용을 처리 중입니다.')

				// step3의 폼데이터를 생성
				this.makeReqParamByStep(this.keyNames.frmName.ctrFrmStep3)
				this.makeReqParamByStep(this.keyNames.frmName.ctrFrmStep3A)

				// 계약요청이나 저장 전 파라미터 데이터를 체크한다
				var isValidDatasToReq = this.validateFinalDataToReq().isValidDatasToReq

				if (isValidDatasToReq) {
					var certStatCode = ''
					var certResMsg = ''

					// 프로세스 진행중에 활성화된 버튼등을 조작해서 문제 생기는것을 방지

					// PG seq 추가
					this.pg.pgSeq = this.paymentPGSeq
					this.$set(this.reqParamJson, 'pgSeq', this.pg)

					// 이메일 메시지 추가
					this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].ctrEmailMessage = this.emailMessage

					// 인증서 서명 선택시 데이터 추가.
					if (this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].ctrSignType === 1) {
						this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].ctrCertSign = this.certResultData.certSign
						this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].ctrPubKey = this.certResultData.certPEM
					}
          // 계약요청 DB 처리를 우선 한다(insert)
          
					writeContractData(convFrmDataToReqJsonParam(this.reqParamJson)).then(response => {
            // 계약요청 insert 성공
						if (response.rcode === 20000) {
							this.$refs.loading.end()
							certStatCode = response.rdata.certStatCode
							certResMsg = response.rdata.certResMsg
							if (certStatCode !== undefined &&
								certStatCode !== '' &&
								Number(certStatCode) === 202) {
								if (response.rdata.payment_info.totalPoint !== undefined && response.rdata.payment_info.totalPoint !== '') {
									this.usePoint = response.rdata.payment_info.usePoint
									this.totalPoint = response.rdata.payment_info.totalPoint
								}
								this.payEnd = true
							} else {
								// 블록체인 인증암호 초기화
								this.ctrFrmStep3A.ctrBlckChainPw = ''
								// 블록체인 요청 오류, 인증실패시 DB 삭제를 위해 셋팅한 contract id를 파라미터에서 삭제
								this.ctrGlobalFrm.ctrSeq = ''
								delete this.ctrGlobalFrm.ctrSeq
								
								this.$refs.loading.end()

								// 에러코드 구분하여 잔액인지, 기존에러인지 분기
								if (certStatCode !== undefined &&
										certStatCode !== '' &&
										certStatCode === '8778') {
											this.$refs.confirm.open('confirm', '계약요청', '포인트 부족').then(() => {
												this.$router.push({ name: 'feePay' })
											}).catch(() => {
												this.$router.push({ name: 'storage' })
											})

								} else {
									if (certResMsg !== undefined && certResMsg != null && certResMsg !== '') {
										this.$refs.confirm.open('alert', '계약요청', certResMsg)
									} else {
										this.$refs.confirm.open('alert', '계약요청', '블록체인 암호 인증에 실패하였습니다. 다시 작업해 주세요.')
									}
								}
							}
						} else {
							// 블록체인 인증암호 초기화
							this.ctrFrmStep3A.ctrBlckChainPw = ''
							// 블록체인 요청 오류, 인증실패시 DB 삭제를 위해 셋팅한 contract id를 파라미터에서 삭제
							this.ctrGlobalFrm.ctrSeq = ''
							delete this.ctrGlobalFrm.ctrSeq
							this.$refs.confirm.open('alert', '계약요청', '계약요청에 실패했습니다. 다시 시도해 주세요.')

							this.$refs.loading.end()
						}
					// }).catch(() => {
					}).catch( e => {
						// 블록체인 인증암호 초기화
						this.ctrFrmStep3A.ctrBlckChainPw = ''
						// 블록체인 요청 오류, 인증실패시 DB 삭제를 위해 셋팅한 contract id를 파라미터에서 삭제
						this.ctrGlobalFrm.ctrSeq = ''
						delete this.ctrGlobalFrm.ctrSeq
						// this.$message.error('계약요청 중 오류가 발생했습니다.')
						// 모든작업사항을 초기화 하고 step1로 이동한다
            this.$refs.confirm.open('alert', '계약요청', e)
						this.$refs.loading.end()
					})
				} else {
					this.$refs.confirm.open('alert', '계약요청', '잘못된 작업이 있어 계약요청 할 수 없습니다. 다시 작업해 주세요.')
					// 모든작업사항을 초기화 하고 step1로 이동한다
					// 블록체인 인증암호 초기화
					this.ctrFrmStep3A.ctrBlckChainPw = ''

					this.$refs.loading.end()
				}
			}
		},
		makeReqParamByStep (frmNm) {
      if (this.step === 3) {
        // 업로드한 계약서, 첨부파일등의 데이터를 셋팅한다
        this.reqParamJson[this.keyNames.reqParamKeys.tmpUploadData] = this.tmpUploadPrc
        if (frmNm === this.keyNames.frmName.ctrFrmStep3) {
          this.reqParamJson[frmNm] = makeNewCtrParamsByStep(this.ctrFrmStep3, this.step)
        } else if (frmNm === this.keyNames.frmName.ctrFrmStep3A) {
          this.reqParamJson[frmNm] = makeNewCtrParamsByStep(this.ctrFrmStep3A, this.step)
        }
      }
    },
    validateFinalDataToReq () {
      // 계약요청이나 저장 전 파라미터 데이터를 체크한다
      let isValidDatasToReq = false
      // 최종 파라미터 데이터 검사를 위해 변환된 데이터로 검사
      var convertedReqJsonData = convFrmDataToReqJsonParam(this.reqParamJson)

      if (this.pdfConvPrc.isFinishConvPDF) { // PDF변환성공여부
        isValidDatasToReq = true
      } else {
        isValidDatasToReq = false
      }

      if (convertedReqJsonData.ctrTblList != null && convertedReqJsonData.ctrTblList.length > 0) { // 수신자 설정 테이블 검사
        // 수신자 설정 테이블에 필수 값이 셋팅 되있는지 확인한다.
        var ctrTblKeyErrCnt = 0

        for (let i = 0; i < convertedReqJsonData.ctrTblList.length; i++) {
          var ctrTblObj = convertedReqJsonData.ctrTblList[i]
          for (var keyName in ctrTblObj) {
            if (keyName !== this.keyNames.ctrTblKeys[keyName]) {
              if (keyName === 'isFirstRecord') { // 필수 키값이 아니므로 pass
                continue
              } else {
                ctrTblKeyErrCnt++
              }
            } else {
              continue
            }
          }
        }

        if (ctrTblKeyErrCnt === 0) {
          isValidDatasToReq = true
        } else {
          isValidDatasToReq = false
        }
      } else {
        isValidDatasToReq = false
      }

      // 첫번째 step의 데이터를 다시 검사한다, 이때는 변환되지 않은 데이터로 검사
      // (ctrGlobalFrm, ctrStep1Frm, ctrTblList 등 검사)
      if (this.hasValidKeyValInCtrStep1Data()) {
        isValidDatasToReq = true
      } else {
        isValidDatasToReq = false
      }

      if (Object.keys(convertedReqJsonData.ctrPaperUpInfo).length > 0) { // 계약서 업로드 검사
        // PDF 변환이 성공하면 PDF 파일명을 계약서 정보에 셋팅하게 된다.
        // 없으면 검증 실패로 판단해야함
        if (convertedReqJsonData.ctrPaperUpInfo[this.keyNames.ctrPaperUpInfoKeys.uploadPDFFileName] !== undefined &&
            convertedReqJsonData.ctrPaperUpInfo[this.keyNames.ctrPaperUpInfoKeys.uploadPDFFileName] != null &&
            convertedReqJsonData.ctrPaperUpInfo[this.keyNames.ctrPaperUpInfoKeys.uploadPDFFileName] !== '') {
          isValidDatasToReq = true
        } else {
          isValidDatasToReq = false
        }
      } else {
        isValidDatasToReq = false
      }

      // 계약요청시의 validation
      if (this.reqKind === this.keyNames.ctrReqMode.ctrReq) {
        if (this.ctrFrmStep3A.ctrBlckChainPw === '') {
          isValidDatasToReq = false
        } else {
          isValidDatasToReq = true
        }
      }
      return {
        isValidDatasToReq: isValidDatasToReq
      }
		},
		hasValidKeyValInCtrStep1Data () {
      // ctrGlobalFrm, ctrTblList 키가 존재하면 우선 파라미터 키는
      // 생성된것으로 판단한다
      let isValidData = false
      let isValidCtrGlobalFrm = false // master데이터 맞는지 검사
      let isValidCtrTblList = false // detail(테이블) 데이터 맞는지 검사
      var whiteSpcTestPattern = /^\s+$/

      // 수신자 설정 테이블의 파라미터 키가 설정되있는지 검사한다
      if (Object.keys(this.reqParamJson).length > 0) {
        for (var key in this.reqParamJson) {
          if (key.indexOf(this.keyNames.frmName.ctrGlobalFrm) > -1) {
            isValidCtrGlobalFrm = true
          }
          if (key.indexOf(this.keyNames.ctrTblListName) > -1) {
            isValidCtrTblList = true
          }
        }

        // 수신자 정보(Master) 검사
        if (
          this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm] !== undefined &&
          this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm] != null &&
          Object.keys(this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm]).length > 0
        ) {
          let errCtrMasterInfoCnt = 0

          var ownerAddress = this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].ownerAddress
          var ownerName = this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].ownerName
          var senderAddress = this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].senderAddress
          var senderName = this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].senderName
          var senderBrokerAddress = this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].senderBrokerAddress
          var receiverAddress = this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].receiverAddress
          var receiverBrokerAddress = this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].receiverBrokerAddress

          if (
            (ownerAddress === undefined || ownerAddress == null || ownerAddress === '' || whiteSpcTestPattern.test(ownerAddress)) &&
            (ownerName === undefined || ownerName == null || ownerName === '' || whiteSpcTestPattern.test(ownerName))
          ) {
            // 수신자 설정 레이어에서 owner,sender 정보들을 셋팅하므로 비어있으면 오류
            errCtrMasterInfoCnt++
          }

          if (
            (senderAddress === undefined || senderAddress == null || senderAddress === '' || whiteSpcTestPattern.test(senderAddress)) &&
            (senderName === undefined || senderName == null || senderName === '' || whiteSpcTestPattern.test(senderName))
          ) {
            // 수신자 설정 레이어에서 owner,sender 정보들을 셋팅하므로 비어있으면 오류
            errCtrMasterInfoCnt++
          }

          if (
            (senderAddress === undefined || senderAddress == null || senderAddress === '' || whiteSpcTestPattern.test(senderAddress)) &&
            (senderBrokerAddress === undefined || senderBrokerAddress == null || senderBrokerAddress === '' || whiteSpcTestPattern.test(senderBrokerAddress))
          ) {
            // 수신자 설정 레이어에서 계약요청, 대행자 체인주소 등의 정보를 셋팅하므로
            // 둘다 없으면 오류
            errCtrMasterInfoCnt++
          }

          if (
            (receiverAddress === undefined || receiverAddress == null || receiverAddress === '' || whiteSpcTestPattern.test(receiverAddress)) &&
            (receiverBrokerAddress === undefined || receiverBrokerAddress == null || receiverBrokerAddress === '' || whiteSpcTestPattern.test(receiverBrokerAddress))
          ) {
            // 수신자 설정 레이어에서 수신자, 수신대행자 체인주소 등의 정보를 셋팅하므로
            // 둘다 없으면 오류
            errCtrMasterInfoCnt++
          }

          if (errCtrMasterInfoCnt > 0) {
            isValidCtrGlobalFrm = false
          }
        }

        // 수신자 테이블(detail) 검사
        if (
          this.reqParamJson[this.keyNames.ctrTblListName] !== undefined &&
          this.reqParamJson[this.keyNames.ctrTblListName] != null &&
          this.reqParamJson[this.keyNames.ctrTblListName].length > 0
        ) {
          let errReceiverInfoCnt = 0

          for (let i = 0; i < this.reqParamJson[this.keyNames.ctrTblListName].length; i++) {
            receiverAddress = this.reqParamJson[this.keyNames.ctrTblListName][i].receiverAddress
            var receiverName = this.reqParamJson[this.keyNames.ctrTblListName][i].receiverName
            receiverBrokerAddress = this.reqParamJson[this.keyNames.ctrTblListName][i].receiverBrokerAddress
            var receiverBrokerName = this.reqParamJson[this.keyNames.ctrTblListName][i].receiverBrokerName

            if (
              (receiverAddress === undefined || receiverAddress === null || receiverAddress === '' || whiteSpcTestPattern.test(receiverAddress)) &&
              (receiverBrokerAddress === undefined || receiverBrokerAddress === null || receiverBrokerAddress === '' || whiteSpcTestPattern.test(receiverBrokerAddress))
            ) {
              // 수신자, 대행자 정보(Chain Address)가 모두 없는 경우
              errReceiverInfoCnt++
            }
            if (
              (receiverName === undefined || receiverName === null || receiverName === '' || whiteSpcTestPattern.test(receiverName)) &&
              (receiverBrokerName === undefined || receiverBrokerName === null || receiverBrokerName === '' || whiteSpcTestPattern.test(receiverBrokerName))
            ) {
              // 수신자, 대행자 정보(수신자명) 가 모두 없는 경우
              errReceiverInfoCnt++
            }
          }

          if (errReceiverInfoCnt > 0) {
            isValidCtrTblList = false
          }
        }
      }

      if (isValidCtrGlobalFrm && isValidCtrTblList) {
        isValidData = true
      } else {
        isValidData = false
      }
      return isValidData
    },
		PGCall () {
      this.paymentBuyer = this.$store.state.user.userid
			this.paymentEmail = this.$store.state.user.useremail
			this.$refs.pgRequest.open()
		},
		PGResponse(pgSeq) {
			this.paymentPGSeq = pgSeq
			this.ctrSetBlckChainPw(this.keyNames.frmName.ctrFrmStep3A)
		},
		payEndMove(page) {
			if(page === 'write') {
				location.reload()
			}else if(page === 'storage') {
				this.$router.push({ name: 'storage' })
			}
		}
	}
}
</script>